import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'

const quiz_delete_question_validation_selector = createSelector(
	[ state => state.quiz ],
	quizState => {
		const valid = quizState.questions.filter(question => question.status !== 'deleting').length > 1
		return {
			valid,
			message: valid?null:localize('quiz_questions_minimum'),
		}
	}
)

export default quiz_delete_question_validation_selector
